import React from "react";

import "./styles.scss"
import ModelComparisonChat from "../../esg-chat/esg-chat/model-comparison";

const CustomModelEvaluation = () => {
    return (
        <div className="custom-model-evaluation-main">
            <ModelComparisonChat />
        </div>
    )
}

export default CustomModelEvaluation